import { render, staticRenderFns } from "./HeaderIndicador.vue?vue&type=template&id=c2b3133c&scoped=true"
import script from "./HeaderIndicador.vue?vue&type=script&lang=js"
export * from "./HeaderIndicador.vue?vue&type=script&lang=js"
import style0 from "./HeaderIndicador.vue?vue&type=style&index=0&id=c2b3133c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b3133c",
  null
  
)

export default component.exports